import { SignIn, SignUp } from "@clerk/clerk-react";
import { useLocation } from "react-router-dom";

export default function AuthPage() {
  const { pathname } = useLocation();
  const isSignUp = pathname.startsWith("/sign-up");
  const Component = isSignUp ? SignUp : SignIn;
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Component
        path={isSignUp ? "/sign-up" : "/sign-in"}
        routing="path"
        signInUrl="/sign-in"
        signUpUrl="/sign-up"
        afterSignInUrl="/dashboard"
        afterSignUpUrl="/dashboard"
      />
    </div>
  );
}
